import config from '../../config'
import { HTTP } from  '../../http'
const pageSize = 15
const deviceModelUri = config.apiEndpoints.deviceModelsUri

export default {
    findAll: (searchOptions, page) => {
        return new Promise((resolve, reject) => {
            const model = {
                "page": page,
                "pageSize": pageSize,
                "keywords": searchOptions.keywords
            }
            HTTP.get(deviceModelUri.concat('search'), { params: model }).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    all: () => {
        return new Promise((resolve, reject) => {
            HTTP.get(deviceModelUri).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    find: (id) =>{
        return new Promise((resolve, reject) => {
            HTTP.get(deviceModelUri.concat(id)).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    create: (model) => {
        return new Promise((resolve, reject) => {
            HTTP.post(deviceModelUri, model).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    update: (model) => {
        return new Promise((resolve, reject) => {
            HTTP.put(deviceModelUri, model).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    }
}